var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTri(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.876 2.55184C11.2175 2.35381 11.6053 2.24951 12 2.24951C12.3948 2.24951 12.7825 2.35381 13.124 2.55184C13.465 2.74953 13.7477 3.03364 13.9437 3.37549L13.9447 3.37723L22.1933 17.6247C22.3904 17.9662 22.4944 18.3535 22.4947 18.7478C22.4951 19.1421 22.3918 19.5295 22.1953 19.8713C21.9987 20.2131 21.7158 20.4973 21.3749 20.6953C21.034 20.8934 20.647 20.9984 20.2527 20.9997L20.25 20.9997H3.75003L3.74739 20.9997C3.3531 20.9984 2.9661 20.8934 2.62516 20.6953C2.28422 20.4973 2.00131 20.2131 1.80477 19.8713C1.60823 19.5295 1.50496 19.1421 1.50531 18.7478C1.50566 18.3535 1.60962 17.9662 1.80676 17.6247L10.0553 3.37723L10.0563 3.37549C10.2524 3.03364 10.5351 2.74953 10.876 2.55184Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTri);
export default __webpack_public_path__ + "static/media/green-tri.f25fef14e699313beea42c1c73efd3ae.svg";
export { ForwardRef as ReactComponent };